import axios, { AxiosInstance } from 'axios';
import {
  ValidData,
  callAxios as callAxios_,
  CallAxiosArgs,
  callAxiosGet as callAxiosGet_,
  downloadFile as downloadFile_,
} from '../tmslib/src/util/axiosutils';
import UrlGrid_, {
  UrlGridArgs as UrlGridArgs_,
} from '../tmslib/src/table/UrlGrid';
import { IId } from '../tmslib/src/table/DataGrid';
import { getApiConfig } from '../config/api';

// API 설정 가져오기
const apiConfig = getApiConfig();

// baseURL 확인 및 디버깅
const BASE_URL = apiConfig.BASE_URL;
console.log('🔧 API BASE_URL:', BASE_URL);

let mainAxios: AxiosInstance | null = null;

export const getMainAxios = () => {
  if (!mainAxios) {
    mainAxios = axios.create({
      baseURL: BASE_URL,
      timeout: apiConfig.TIMEOUT,
      headers: apiConfig.DEFAULT_HEADERS,
    });
    
    // 요청 인터셉터 추가
    mainAxios.interceptors.request.use(
      (config) => {
        const token = localStorage.getItem('fds_token');
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        console.log('🔧 [Axios 요청]', config.method?.toUpperCase(), config.url);
        console.log('🔧 [Axios 요청] 전체 URL:', config.baseURL + config.url);
        console.log('🔧 [Axios 요청] 파라미터:', config.params);
        return config;
      },
      (error) => {
        console.error('🔧 [Axios 요청 에러]', error);
        return Promise.reject(error);
      }
    );
    
    // 응답 인터셉터 추가
    mainAxios.interceptors.response.use(
      (response) => {
        console.log('🔧 [Axios 응답]', response.status, response.config.url);
        return response;
      },
      (error) => {
        console.error('🔧 [Axios 응답 에러]', error.config?.url, error.response?.status, error.message);
        if (error.response) {
          console.error('🔧 [Axios 응답 에러] 상태:', error.response.status);
          console.error('🔧 [Axios 응답 에러] 데이터:', error.response.data);
        } else if (error.request) {
          console.error('🔧 [Axios 응답 에러] 요청은 보냈지만 응답을 받지 못함');
        } else {
          console.error('🔧 [Axios 응답 에러] 요청 설정 중 에러:', error.message);
        }
        return Promise.reject(error);
      }
    );
    
    console.log('🔧 Axios Instance 생성:', mainAxios.defaults.baseURL);
  }
  return mainAxios;
};

export type UrlGridArgs<T extends IId> = Omit<UrlGridArgs_<T>, 'axiosInstance'>;

export const UrlGrid = <T extends IId>({
  args,
  params,
  refreshNeeded,
}: {
  args: UrlGridArgs<T>;
  params: object;
  refreshNeeded?: number;
}) =>
  UrlGrid_({
    args: { ...args, axiosInstance: getMainAxios() },
    params,
    refreshNeeded,
  });

export type { ValidData };

export const callAxios = (args: Omit<CallAxiosArgs, 'axiosInstance'>) =>
  callAxios_({ ...args, axiosInstance: getMainAxios() });

export const callAxiosGet = (
  args: Omit<CallAxiosArgs, 'isGet' | 'axiosInstance'>,
) => callAxiosGet_({ ...args, axiosInstance: getMainAxios() });

export const downloadFile = (
  args: Omit<CallAxiosArgs, 'responseType' | 'onSuccess' | 'axiosInstance'>,
) => downloadFile_({ ...args, axiosInstance: getMainAxios() });

